var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "46D3B8E1-736A-4348-9395-30C88EC2660C")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Page-V10",
    transform: "translate(-968.000000, -8742.000000)",
    fill: "#283580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(1.000000, 8650.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(932.000400, 91.999400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2466,18.5526 L39.4076,18.5526 L39.4076,6.0336 L35.2466,6.0336 L35.2466,18.5526 Z M37.3546,0.0006 C35.9316,0.0006 34.9996,0.9346 34.9996,2.1626 C34.9996,3.3646 35.9046,4.3266 37.2996,4.3266 L37.3276,4.3266 C38.7796,4.3266 39.6816,3.3646 39.6816,2.1626 C39.6546,0.9346 38.7796,0.0006 37.3546,0.0006 L37.3546,0.0006 Z M54.4146,11.3746 L54.4146,18.5526 L50.2536,18.5526 L50.2536,11.8556 C50.2536,10.1736 49.6516,9.0246 48.1456,9.0246 C46.9956,9.0246 46.3116,9.7996 46.0096,10.5476 C45.9006,10.8146 45.8726,11.1866 45.8726,11.5616 L45.8726,18.5526 L41.7096,18.5526 C41.7096,18.5526 41.7656,7.2106 41.7096,6.0346 L45.8716,6.0346 L45.8716,7.8086 C45.8636,7.8226 45.8526,7.8366 45.8446,7.8496 L45.8716,7.8496 L45.8716,7.8086 C46.4246,6.9576 47.4126,5.7406 49.6226,5.7406 C52.3616,5.7406 54.4146,7.5296 54.4146,11.3746 L54.4146,11.3746 Z",
    id: "Linked-In"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.c8663444.svg";
export { ForwardRef as ReactComponent };